import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo, useRef } from 'react';
import {
  Notification_Category,
  Notification_ReadState,
} from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/notification_pb';
import { listNotificationsInfiniteQuery } from '~/shared/api/listNotifications.queries';

export function useNotifications(
  readStateFilter: Notification_ReadState = Notification_ReadState.UNSPECIFIED,
  categoryFilter: Notification_Category = Notification_Category.UNSPECIFIED,
  filterDeviceName = '',
) {
  const {
    data,
    isLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    listNotificationsInfiniteQuery(
      readStateFilter,
      categoryFilter,
      filterDeviceName,
    ),
  );

  const notifications = useMemo(
    () => data?.pages.flatMap((page) => page.notifications) ?? [],
    [data],
  );

  const latestCounts = data?.pages[0]?.globalCategoryCounts;
  const cachedCountsRef = useRef(latestCounts);
  if (latestCounts) {
    cachedCountsRef.current = latestCounts;
  }

  return {
    notifications,
    globalCategoryCounts: cachedCountsRef.current ?? [],
    isLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  };
}
